import React from 'react';
import { compose, graphql, withApollo } from 'react-apollo';
import {
  getCategoryById,
  updateCategory,
  updateItemPosition,
} from '../schema/shop-schema.graphql';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ShoppingCart from '@material-ui/icons/ShoppingCart';
import List from '@material-ui/icons/List';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import ItemTable from './ItemTable';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import FormControl from '@material-ui/core/FormControl';
import { withSnackbar } from '../../snackbar/SnackbarContext';
import Button from 'components/CustomButtons/Button.jsx';
import Clearfix from 'components/Clearfix/Clearfix.jsx';
import Typography from '@material-ui/core/Typography';
import localization from '../../../i18n/localization';
import InputLabel from '@material-ui/core/InputLabel';
import Switch from '@material-ui/core/Switch';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  label: {
    fontSize: 14,
  },
  icon: {
    marginRigth: '50px',
  },
});

class Category extends React.Component {
  state = {
    page: 0,
    rowsPerPage: 50,
    category: {
      enabled: false,
      items: [],
    },
  };

  updateCategory = async () => {
    const { updateCategory, addNotification } = this.props;
    const { category } = this.state;

    const { data } = await updateCategory({
      variables: {
        category: {
          id: category.id,
          enabled: category.enabled,
        },
      },
    });

    this.setState(prevState => ({
      ...prevState,
      category: data.category,
    }));
    addNotification('success', localization.de.shop.OPERATION_SUCCESS);
  };

  changePosition = event => {
    const value = event.target.value;
    this.setState(prevState => ({
      ...prevState,
      category: {
        ...prevState.category,
        position: value,
      },
    }));
  };

  changeEnabled = () => {
    this.setState(prevState => ({
      ...prevState,
      category: {
        ...prevState.category,
        enabled: !prevState.category.enabled,
      },
    }));
  };

  onPositionChange = async (item, direction) => {
    const { updateItemPosition, addNotification } = this.props;

    const { data } = await updateItemPosition({
      variables: {
        itemUpdatePosition: {
          id: item.id,
          direction: direction,
        },
      },
    });

    this.setState(prevState => ({
      ...prevState,
      category: data.category,
    }));
    addNotification('success', localization.de.shop.OPERATION_SUCCESS);
  };

  getCategoryWithItems = async () => {
    const { client, match } = this.props;

    const { data } = await client.query({
      query: getCategoryById,
      variables: {
        id: match.params.id,
      },
    });

    this.setState(prevState => ({
      ...prevState,
      category: data.category,
    }));
  };

  componentDidMount() {
    this.getCategoryWithItems();
  }

  render() {
    const { classes, history } = this.props;
    const { category } = this.state;

    return (
      <div className={classes.root}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="info">
              <ShoppingCart />
            </CardIcon>
            <div
              style={{
                marginTop: 60,
                marginBottom: 25,
                display: 'flex',
                width: '100%',
                alignItems: 'flex-start',
              }}
            >
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                }}
              >
                <Typography variant="headline" color="textSecondary">
                  {localization.de.shop.CATEGORY}
                </Typography>
              </div>
            </div>
          </CardHeader>
          <CardBody>
            <React.Fragment>
              <GridContainer>
                <GridItem xs={12} sm={6} md={4} lg={4}>
                  <FormControl fullWidth={true}>
                    <InputLabel
                      htmlFor={localization.de.shop.categoryTable.ID}
                      className={classes.inputLabel}
                    >
                      {localization.de.shop.categoryTable.ID}
                    </InputLabel>
                  </FormControl>
                  <div />
                  <FormControl fullWidth={true}>
                    <CustomInput
                      inputProps={{
                        name: localization.de.shop.categoryTable.ID,
                        value: category.id,
                        disabled: true,
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={4} lg={4}>
                  <FormControl fullWidth={true}>
                    <InputLabel
                      htmlFor={localization.de.shop.categoryTable.TITLE}
                      className={classes.inputLabel}
                    >
                      {localization.de.shop.categoryTable.TITLE}
                    </InputLabel>
                  </FormControl>
                  <div />
                  <FormControl fullWidth={true}>
                    <CustomInput
                      inputProps={{
                        name: localization.de.shop.categoryTable.TITLE,
                        value: category.title,
                        disabled: true,
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={4} lg={4}>
                  <FormControl fullWidth={true}>
                    <InputLabel
                      htmlFor={localization.de.shop.categoryTable.TYPE}
                      className={classes.inputLabel}
                    >
                      {localization.de.shop.categoryTable.TYPE}
                    </InputLabel>
                  </FormControl>
                  <div />
                  <FormControl fullWidth={true}>
                    <CustomInput
                      inputProps={{
                        name: localization.de.shop.categoryTable.TYPE,
                        value: category.type,
                        disabled: true,
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </FormControl>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={6} md={6} lg={6}>
                  <FormControl fullWidth={true}>
                    <InputLabel
                      htmlFor={localization.de.shop.categoryTable.POSITION}
                      className={classes.inputLabel}
                    >
                      {localization.de.shop.categoryTable.POSITION}
                    </InputLabel>
                  </FormControl>
                  <div />
                  <FormControl fullWidth={true}>
                    <CustomInput
                      inputProps={{
                        value: category.position,
                        onChange: this.changePosition,
                        disabled: true,
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={6} lg={6}>
                  <FormControl fullWidth={true}>
                    <InputLabel
                      htmlFor={localization.de.shop.categoryTable.ENABLED}
                      className={classes.label}
                    >
                      {localization.de.shop.categoryTable.ENABLED}
                    </InputLabel>
                  </FormControl>
                  <div style={{ marginTop: 20 }} />
                  <FormControl fullWidth={true}>
                    <Switch
                      onChange={this.changeEnabled}
                      checked={category.enabled}
                      color={'primary'}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <Button
                    style={{ marginTop: 40 }}
                    color="info"
                    onClick={this.updateCategory}
                  >
                    {localization.de.shop.SAVE}
                  </Button>
                  <Clearfix />
                </GridItem>
              </GridContainer>
            </React.Fragment>
          </CardBody>
        </Card>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="info">
              <List />
            </CardIcon>
            <div
              style={{
                marginTop: 60,
                marginBottom: 25,
                display: 'flex',
                width: '100%',
                alignItems: 'flex-start',
              }}
            >
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                }}
              >
                <Typography variant="headline" color="textSecondary">
                  {localization.de.shop.ITEMS}
                </Typography>
              </div>
            </div>
          </CardHeader>
          <CardBody>
            <React.Fragment>
              <ItemTable
                items={category.items}
                onClick={id => history.push(`/shop/item/${id}`)}
                onPositionChange={(item, direction) =>
                  this.onPositionChange(item, direction)
                }
              />
              <GridContainer>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <Button
                    style={{ marginTop: 40 }}
                    color="info"
                    onClick={() => history.push(`/shop`)}
                  >
                    {localization.de.shop.BACK}
                  </Button>
                  <Clearfix />
                </GridItem>
              </GridContainer>
            </React.Fragment>
          </CardBody>
        </Card>
      </div>
    );
  }
}

Category.propTypes = {
  match: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const enhance = compose(
  graphql(updateCategory, { name: 'updateCategory' }),
  graphql(updateItemPosition, { name: 'updateItemPosition' }),
  withStyles({ ...styles }),
  withSnackbar,
  withApollo
);

export default enhance(Category);



// WEBPACK FOOTER //
// ./src/views/shop/components/Category.jsx